import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import MobileStoreQrLabel from '~/src/features/agent/components/QrLabel';

export const HeaderWrapper = styled.div`
    width: 100%;
    background-color: ${COLORS.BgMain};
    overflow: hidden;
`;

export const Container = styled(WideContainer)`
    position: relative;

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 1216px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        flex-direction: column;
        flex-wrap: nowrap;
    }
`;

export const ContentBlock = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    flex-basis: 440px;
    margin: 122px 0;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin: 108px 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 82px;
        margin-bottom: 99px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-top: 60px;
        margin-bottom: 79px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-basis: auto;
        margin-top: 40px;
        margin-bottom: 48px;
    }
`;

export const PageTitle = styled.h1`
    margin-top: 0;
    margin-bottom: 16px;
    max-width: 424px;
    ${FONTS.H0};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        margin-bottom: 8px;
    }
`;

export const Desc = styled.div`
    margin-bottom: 40px;
    ${FONTS.L};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.S};
        margin-bottom: 32px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 24px;
    }
`;

export const ImageBlock = styled.div`
    position: absolute;
    top: 0;
    right: 112px;
    bottom: 0;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        right: 23px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        right: -171px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        right: -30px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        position: static;
        justify-content: center;
    }
`;

export const ImageBlockInnerWrapper = styled.div`
    position: relative;
    width: 720px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 600px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 600px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 360px;
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        width: 100%;
    }
`;

export const MainImage = styled.img`
    width: 100%;
    height: 100%;
    object-position: bottom;
    object-fit: contain;
`;

export const SMobileStoreQrLabel = styled(MobileStoreQrLabel)`
    position: absolute;
    bottom: 90px;
    left: 23px;
    transform: rotate(-11deg);

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        bottom: 73px;
        left: 10px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        bottom: 98px;
        left: 0px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        display: none;
    }
`;
